// extracted by mini-css-extract-plugin
export var animationContainer = "_c6-0";
export var asteriskIcon = "_c6-8";
export var conversationLeftSection = "_c6-4";
export var conversationListItem = "_c6-3";
export var conversationMiddleSection = "_c6-5";
export var conversationRightSection = "_c6-6";
export var detailsContent = "_c6-1";
export var listContainer = "_c6-7";
export var modalContent = "_c6-2";